import { useState, useEffect } from "react";
import { Menu, Layout, Button, Drawer } from "antd";
import {
  HomeOutlined, LogoutOutlined,
  MenuOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import { Link, useLocation, Outlet, useNavigate} from "react-router-dom";
import logo_dark from "../img/logo_white.png";
import AppFooter from "../components/Footer";
import "./MainLayout.css";
import { useAuth } from "../components/AuthContext";
import authService from "../services/auth.service";

const { Header, Content } = Layout;

function MainLayoutAdmin({ setIsLoggedIn }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const logoutHandler = async () => {
      try {
        await authService.logout();
        logout();
        navigate("/home");
      } catch (error) {
      }
    };

    const getSectionTitle = () => {
  const path = location.pathname;

  if (path.includes("/korisnickiNalozi")) return "Korisnički nalozi";
  if (path.includes("/home")) return "Početna stranica";

  return ""; 
};

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuClick = ({ key }) => {
    navigate(key);
    
    setDrawerVisible(false);
  };
  
  const renderMenu = () => (
    <Menu
      selectedKeys={[location.pathname]}
      mode="inline"
      onClick={handleMenuClick}
    >
      <Menu.Item key="/admin/home" icon={<HomeOutlined />}>
        Početna stranica
      </Menu.Item>

      <Menu.Item key="/admin/korisnickiNalozi" icon={<ProfileOutlined />}>
        Korisnički nalozi
      </Menu.Item>

    </Menu>
  );

  return (
      <Layout style={{ minHeight: "100vh", backgroundColor: "transparent" }}>
      <Header className="custom-header">
        <div className="header-left">
            <Button
              className="menu-toggle"
              icon={<MenuOutlined />}
              onClick={() => setDrawerVisible(true)}
            />
          <Link to="/admin/home">
            <img
              src={logo_dark}
              alt="Logo"
              className="header-logo clickable-logo"
            />
          </Link>
        </div>

        <div className="header-right">
          <Button
            className="user_button"
            icon={<LogoutOutlined />}
            onClick={logoutHandler}
          />
        </div>
      </Header>

       <div className="docs-div2">
  <p className="docs-p">{getSectionTitle()}</p>
</div>

  <Drawer
        title="Navigacija"
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width="20%"
        bodyStyle={{ padding: 0 }}
        style={{ height: "100%", maxHeight: "100%" }}
      >
        {renderMenu()}
      </Drawer>

    <Layout className="site-layout">
        <Content style={{ minHeight: "280px" }}>
          <Outlet />
        </Content>
        <AppFooter />
      </Layout>
    </Layout>
  );
}

export default MainLayoutAdmin;